module.exports = __webpack_public_path__ + "static/img/3e.02101a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3e.jpg
// module id = F3xU
// module chunks = 0